import React, { useState } from 'react';
import { Button, Flex, Modal, Table, Tag, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { clrs } from "../../constants/colors";
import MyText from "../../components/UI/Text/MyText";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import user_icon from "./images/user_icon.png";
import img1 from "./images/1.png";
import img2 from "./images/2.jpg";
import img3 from "./images/3.jpg";
import img5 from "./images/5.jpg";
import img10 from "./images/10.jpg";
import img11 from "./images/11.jpeg";
import img14 from "./images/14.jpeg";
import img15 from "./images/15.jpg";
import img19 from "./images/19.jpg";
import img23 from "./images/23.JPG";
import img25 from "./images/25.jpg";
import img27 from "./images/27.jpg";
import img29 from "./images/29.png";
import { PersonNeftissov } from "./components/PersonNeftissov";
import { PersonBiloshchytskyi } from "./components/PersonBiloshchytskyi";
import { PersonKuchanskyi } from "./components/PersonKuchanskyi";
import { PersonToxanov } from "./components/PersonToxanov";
import { PersonAbzhanova } from "./components/PersonAbzhanova";
import { PersonKazambayev } from "./components/PersonKazambayev";
import { PersonKirichenko } from "./components/PersonKirichenko";
import { PersonKambarova } from "./components/PersonKambarova";
import { PersonAubakirova } from "./components/PersonAubakirova";
import { PersonMikryakov } from "./components/PersonMikryakov";
import { PersonBakytkereiuly } from "./components/PersonBakytkereiuly";
import { PersonZhalmagambetova } from "./components/PersonZhalmagambetova";
import { PersonKomandirov } from "./components/PersonKomandirov";

const roleColors = {
    'Научный руководитель, старший научный сотрудник': '#4a6fa5',
    'Старший научный сотрудник': '#4a6fa5',
    'Научный сотрудник': '#5a7a9a',
    'Младший научный сотрудник': '#5c8a7a',
    'Менеджер проекта': '#7a8a95',
    'Менеджер по кадрам по научной программе': '#7a8a95',
    'Программист': '#6a7e9a',
    'Разработчик': '#6a7e9a',
    'Разработчик ГИС': '#6a7e9a',
    'Разработчик базы данных': '#6a7e9a',
    'Разработчик математических моделей': '#6a7e9a',
    'Разработчик ИИ': '#6a7e9a',
    'Инженер-проектировщик': '#6a7e9a',
    'Специалист': '#7a8a95',
    'Специалист по автоматизированным системам': '#7a8a95',
};

const getRoleColor = (role) => roleColors[role] || clrs.textColor;

const teamData = [
    { key: 1,  name: 'Нефтисов Александр Витальевич',        role: 'Научный руководитель, старший научный сотрудник', image: img2,      detail: <PersonNeftissov /> },
    { key: 2,  name: 'Белошицкий Андрей Александрович',       role: 'Старший научный сотрудник',                       image: img1,      detail: <PersonBiloshchytskyi /> },
    { key: 3,  name: 'Казамбаев Ильяс Маратулы',             role: 'Научный сотрудник',                               image: img14,     detail: <PersonKazambayev /> },
    { key: 4,  name: 'Кириченко Лалита Николаевна',           role: 'Научный сотрудник',                               image: img15,     detail: <PersonKirichenko /> },
    { key: 5,  name: 'Токсанов Сапар Нурахметович',           role: 'Научный сотрудник',                               image: img5,      detail: <PersonToxanov /> },
    { key: 6,  name: 'Жандаулет Елдос Жандаулетұлы',         role: 'Разработчик математических моделей',              image: user_icon, detail: null },
    { key: 7,  name: 'Абжанова Дилара Ерлановна',            role: 'Разработчик базы данных',                         image: img10,     detail: <PersonAbzhanova /> },
    { key: 8,  name: 'Кучанский Александр',                   role: 'Старший научный сотрудник',                       image: img3,      detail: <PersonKuchanskyi /> },
    { key: 9,  name: 'Камбарова Жулдуз Думанбековна',         role: 'Менеджер проекта',                                image: img29,     detail: <PersonKambarova /> },
    { key: 10, name: 'Искакова Еренгуль Елкеновна',           role: 'Менеджер по кадрам по научной программе',         image: user_icon, detail: null },
    { key: 11, name: 'Аубакирова Алия Муратовна',             role: 'Младший научный сотрудник',                       image: img27,     detail: <PersonAubakirova /> },
    { key: 12, name: 'Белощицкий Артем',                      role: 'Программист',                                     image: user_icon, detail: null },
    { key: 13, name: 'Белощицкий Евгений',                    role: 'Программист',                                     image: user_icon, detail: null },
    { key: 14, name: 'Медетхан Айнур Сейтжанкызы',            role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 15, name: 'Амангелді Мағжан Айтмұратұлы',          role: 'Разработчик',                                     image: user_icon, detail: null },
    { key: 16, name: 'Тасыбаев Дамир Булатович',              role: 'Разработчик',                                     image: user_icon, detail: null },
    { key: 17, name: 'Вакансия',                              role: 'Разработчик',                                     image: user_icon, detail: null },
    { key: 18, name: 'Стевальга Олег Владимирович',           role: 'Разработчик',                                     image: user_icon, detail: null },
    { key: 19, name: 'Микряков Андрей Денисович',             role: 'Младший научный сотрудник',                       image: img25,     detail: <PersonMikryakov /> },
    { key: 20, name: 'Бақыткерей Батырбек',                   role: 'Разработчик ГИС',                                 image: img11,     detail: <PersonBakytkereiuly /> },
    { key: 21, name: 'Омарова Перизат Танирбердиевна',        role: 'Научный сотрудник',                               image: user_icon, detail: null },
    { key: 22, name: 'Гончаренко Татьяна Андреевна',          role: 'Научный сотрудник',                               image: user_icon, detail: null },
    { key: 23, name: 'Кажибеков Мади Нуржанович',             role: 'Разработчик',                                     image: user_icon, detail: null },
    { key: 24, name: 'Бакбергенов Али Бахтыбаевич',           role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 25, name: 'Абилькаиров Даулет Максутович',         role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 26, name: 'Абдибаев Жанузак Архабайулы',           role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 27, name: 'Жалмагамбетова Ултуар Каирболатовна',   role: 'Специалист по автоматизированным системам',       image: img23,     detail: <PersonZhalmagambetova /> },
    { key: 28, name: 'Командиров Евгений Витальевич',         role: 'Инженер-проектировщик',                           image: img19,     detail: <PersonKomandirov /> },
    { key: 29, name: 'Баяндина Гульмира Дуйсенбаевна',        role: 'Специалист',                                      image: user_icon, detail: null },
    { key: 30, name: 'Оразбай Мұхтар Нұрболұлы',             role: 'Разработчик ИИ',                                  image: user_icon, detail: null },
];

const CARD_W = 210;
const CARD_IMG_H = 240;
const CARD_TEXT_H = 130;

const MemberCard = ({ member, onOpenDetail }) => {
    const hasDetail = member.detail !== null;
    return (
        <Flex
            vertical
            align="center"
            style={{
                width: CARD_W,
                borderRadius: 16,
                overflow: "hidden",
                background: clrs.white,
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                border: `1px solid ${clrs.whiter2}`,
                cursor: hasDetail ? "pointer" : "default",
                transition: "transform 0.2s, box-shadow 0.2s",
            }}
            className="member-card"
            onClick={() => hasDetail && onOpenDetail(member)}
        >
            <div style={{
                width: "100%",
                height: CARD_IMG_H,
                backgroundImage: `url(${member.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center top",
                flexShrink: 0,
            }} />
            <Flex
                vertical
                align="center"
                justify="space-between"
                gap={6}
                style={{
                    padding: "14px 12px 12px",
                    width: "100%",
                    height: CARD_TEXT_H,
                    boxSizing: "border-box",
                }}
            >
                <Flex vertical align="center" gap={5} style={{ flex: 1 }}>
                    <MyText
                        strong
                        style={{
                            fontSize: "0.83rem",
                            color: clrs.textColor,
                            textAlign: "center",
                            lineHeight: 1.35,
                            margin: 0,
                        }}
                    >
                        {member.name}
                    </MyText>
                    <MyText
                        italic
                        style={{
                            fontSize: "0.76rem",
                            color: getRoleColor(member.role),
                            textAlign: "center",
                            lineHeight: 1.3,
                            margin: 0,
                        }}
                    >
                        {member.role}
                    </MyText>
                </Flex>
            </Flex>
        </Flex>
    );
};

const TeamPage = () => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [view, setView] = useState('cards');

    const handleOpen = (member) => {
        setSelected(member);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelected(null);
    };

    const columns = [
        {
            title: '',
            key: 'action',
            width: 56,
            render: (_, record) =>
                record.detail ? (
                    <Tooltip title="Подробнее">
                        <Button
                            type="text"
                            size="small"
                            icon={<EyeOutlined style={{ color: "#8fa3b8" }} />}
                            onClick={() => handleOpen(record)}
                            style={{ color: "#8fa3b8" }}
                        />
                    </Tooltip>
                ) : null,
        },
        {
            title: '',
            key: 'photo',
            width: 56,
            render: (_, record) => (
                <div
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundImage: `url(${record.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center top",
                        border: `2px solid ${clrs.whiter2}`,
                    }}
                />
            ),
        },
        {
            title: 'ФИО',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <MyText
                    style={{
                        cursor: record.detail ? "pointer" : "default",
                        color: record.detail ? "#4a6fa5" : "#5a6a7a",
                        fontWeight: record.detail ? 500 : 400,
                    }}
                    onClick={() => record.detail && handleOpen(record)}
                >
                    {text}
                </MyText>
            ),
        },
        {
            title: 'Роль в проекте',
            dataIndex: 'role',
            key: 'role',
            render: (role) => (
                <Tag
                    style={{
                        background: `${getRoleColor(role)}14`,
                        border: `1px solid ${getRoleColor(role)}30`,
                        color: getRoleColor(role),
                        borderRadius: 6,
                        fontWeight: 400,
                        fontSize: "0.82rem",
                    }}
                >
                    {role}
                </Tag>
            ),
        },
    ];

    return (
        <div style={{ background: clrs.whiter3AquaGeo, minHeight: "100vh" }}>
            <Header />

            <style>{`
                .member-card:hover { transform: translateY(-4px); box-shadow: 0 8px 28px rgba(0,0,0,0.14) !important; }
            `}</style>

            <Flex
                justify="center"
                style={{ width: "100%", padding: "120px 20px 80px" }}
            >
                <Flex
                    vertical
                    gap={40}
                    style={{ width: "100%", maxWidth: 1440 }}
                >
                    {/* Header section */}
                    <Flex vertical align="center" gap={12} style={{ textAlign: "center" }}>
                        <Flex align="center" gap={12} justify="center">
                            <MyText
                                strong
                                style={{
                                    fontSize: "2.2rem",
                                    fontWeight: 900,
                                    color: clrs.textColor,
                                }}
                            >
                                Научный коллектив
                            </MyText>
                        </Flex>
                        <MyText
                            style={{
                                fontSize: "1rem",
                                color: clrs.whiterBlacker,
                                maxWidth: 700,
                                lineHeight: 1.6,
                            }}
                        >
                            Проект BR24993128 — «Разработка информационно-аналитической системы для принятия решений для эффективного использования трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона»
                        </MyText>
                        <Flex gap={8} style={{ marginTop: 8 }}>
                            <Tag style={{ background: `${clrs.blue}15`, border: `1px solid ${clrs.blue}40`, color: clrs.blue, borderRadius: 20, padding: "4px 12px" }}>
                                {teamData.length} участников
                            </Tag>
                            <Tag style={{ background: `${clrs.whiterGreen}25`, border: `1px solid ${clrs.whiterGreen}60`, color: clrs.darkerBlue, borderRadius: 20, padding: "4px 12px" }}>
                                {teamData.filter(m => m.detail).length} профилей
                            </Tag>
                        </Flex>
                    </Flex>

                    {/* View toggle */}
                    <Flex justify="flex-end" gap={8}>
                        <Button
                            type={view === 'cards' ? 'primary' : 'default'}
                            onClick={() => setView('cards')}
                            style={{ borderRadius: 8 }}
                        >
                            Карточки
                        </Button>
                        <Button
                            type={view === 'table' ? 'primary' : 'default'}
                            onClick={() => setView('table')}
                            style={{ borderRadius: 8 }}
                        >
                            Таблица
                        </Button>
                    </Flex>

                    {/* Cards view */}
                    {view === 'cards' && (
                        <Flex wrap="wrap" gap={24} justify="center">
                            {teamData.map(member => (
                                <MemberCard key={member.key} member={member} onOpenDetail={handleOpen} />
                            ))}
                        </Flex>
                    )}

                    {/* Table view */}
                    {view === 'table' && (
                        <div style={{
                            background: clrs.white,
                            borderRadius: 16,
                            overflow: "hidden",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                        }}>
                            <Table
                                columns={columns}
                                dataSource={teamData}
                                pagination={false}
                                rowKey="key"
                                size="middle"
                                onRow={(record) => ({
                                    style: {
                                        cursor: record.detail ? "pointer" : "default",
                                        transition: "background 0.15s",
                                    },
                                })}
                            />
                        </div>
                    )}
                </Flex>
            </Flex>

            {/* Detail modal */}
            <Modal
                title={
                    <Flex align="center" gap={10}>
                        {selected && (
                            <div style={{
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                backgroundImage: `url(${selected?.image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center top",
                                flexShrink: 0,
                            }} />
                        )}
                        <span>{selected?.name}</span>
                    </Flex>
                }
                open={open}
                onOk={handleClose}
                onCancel={handleClose}
                footer={[
                    <Button key="ok" type="primary" onClick={handleClose} style={{ borderRadius: 8 }}>
                        Закрыть
                    </Button>
                ]}
                width={900}
                style={{ top: 40 }}
                styles={{ body: { maxHeight: "70vh", overflowY: "auto", padding: "24px" } }}
            >
                {selected?.detail}
            </Modal>

            <Footer />
        </div>
    );
};

export default TeamPage;
